import {Component, Input, OnInit} from '@angular/core';
import {interval, Subscription} from "rxjs";

@Component({
  selector: 'app-card-graph-line',
  templateUrl: './card-graph-line.component.html',
  styleUrls: ['./card-graph-line.component.css']
})
export class CardGraphLineComponent implements OnInit {
  @Input() value: number = 0;
  private updateSubscription: Subscription | undefined;

  public data: number[]
    = [
    1.907, 2.943, 3.848, 4.284, 5.263, 6.801, 7.89, 9.238, 9.552, 10.855,
  ];



  public categories: number[] = [
    1,2,3,4,5,6,7,8,9,10,11
  ];


  constructor() { }


  UpdateChannel(): void {
    console.log("Update sr");

    // Clone the array
    const data = this.data.slice(0);

    // Produce one random value each 100ms
    data.push(this.value);

    if (data.length > 10) {
      // Keep only 10 items in the array
      data.shift();
    }

    // Replace with the new array instance
    this.data = data;
    console.log("Update donm");

    //
    // this.data[1] = 33.00;
    // this.data[2] = 1.00;
    // this.data[8] = Math.random()*10;
    // this.data[9] = this.value;

  }


  ngOnInit(): void {


  }

}
